import { render, staticRenderFns } from "./color-scheme-select.vue?vue&type=template&id=0b3f2b2e&scoped=true"
import script from "./color-scheme-select.vue?vue&type=script&lang=js"
export * from "./color-scheme-select.vue?vue&type=script&lang=js"
import style0 from "./color-scheme-select.vue?vue&type=style&index=0&id=0b3f2b2e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b3f2b2e",
  null
  
)

export default component.exports